const shoppingMall = [
  {
    path: '/shop/helpServiceList',
    name: 'HelpServiceList',
    component: () => import('@/views/shoppingMall/HelpAndService/HelpAndServiceList/index'),
    meta: {
      title: '帮助与客服',
      keepAlive: true,
      auth: true,
      isWechat: false
    }
  },
  {
    path: '/shop/helpServiceDetail',
    name: 'HelpServiceDetail',
    component: () => import('@/views/shoppingMall/HelpAndService/HelpAndServiceDetail/index'),
    meta: {
      title: '解决方案',
      keepAlive: true,
      auth: true,
      isWechat: false
    }
  },
  {
    path: '/shop/bargainIndex',
    name: 'Bargain',
    component: () => import('@/views/shoppingMall/bargain/index/index'),
    meta: {
      title: '砍价团',
      keepAlive: true,
      auth: true,
      isWechat: true,
      isBindMobile: true
    }
  },
  {
    path: '/shop/bargainGoodsDetail',
    name: 'BargainGoodsDetail',
    component: () => import('@/views/shoppingMall/goodsDetail/index'),
    meta: {
      title: '砍价详情',
      keepAlive: true,
      auth: true,
      isWechat: true,
      isBindMobile: true
    }
  },
  {
    path: '/shop/BargainEnjoy',
    name: 'BargainEnjoy',
    component: () => import('@/views/shoppingMall/bargain/bargainEnjoy/index'),
    meta: {
      title: '砍价分享',
      keepAlive: true,
      auth: false,
      isWechat: true,
      isBindMobile: true
    }
  },
  {
    path: '/shop/BargainOrderList',
    name: 'BargainOrderList',
    component: () => import('@/views/shoppingMall/bargain/order/index'),
    meta: {
      title: '砍价订单',
      keepAlive: true,
      auth: true,
      isWechat: true,
      isBindMobile: true
    }
  },
  {
    path: '/shop/bindMobile',
    name: 'BindMobile',
    component: () => import('@/views/shoppingMall/login/bindMobile/index'),
    meta: {
      title: '绑定手机号码',
      keepAlive: true,
      auth: false,
      isWechat: true,
      isBindMobile: false
    }
  },
  {
    path: '/shop/exchangeGoods/index',
    name: 'ExchangeGoods',
    component: () => import('@/views/shoppingMall/exchangeGoods/index/index'),
    meta: {
      title: '去兑换',
      keepAlive: true,
      auth: true,
      isWechat: false
    }
  }
]
export default shoppingMall



// WEBPACK FOOTER //
// ./src/router/modules/shoppingMall.js